import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./en.json";

// English first. Every visible text goes through these files so French can be
// added as fr.json without touching the screens.
void i18n.use(initReactI18next).init({
  resources: { en: { translation: en } },
  lng: "en",
  fallbackLng: "en",
  interpolation: { escapeValue: false },
  returnNull: false,
  showSupportNotice: false,
});

export default i18n;
